<div class="chart-tooltip-wrapper d-flex flex-column p-2">
    <h6>{{tooltipConfig.axisLabel}}</h6>
    <div class="row m-0" *ngFor="let line of tooltipConfig.data">
        <span class="p-0" style="font-family: 'bootstrap-icons'; width: 20px">{{line.label}}</span>
        <span class="col p-0">: {{line.value}}</span>
    </div>
</div>